
import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress
} from "@mui/material";
import {  linkOfferToBranch } from "../../../../services/pos/Tables";
import { fetchActiveBranches } from "../../../../services/apiServiceDashboard";

const LinkOfferModal = ({ offerId, isOpen, onClose, onSuccess }) => {
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const loadBranches = async () => {
      try {
        const data = await fetchActiveBranches();
        setBranches(data);
      } catch (error) {
        alert(error.message);
      }
    };
    loadBranches();
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!selectedBranch) return alert("❗ الرجاء اختيار فرع");
    setLoading(true);
    try {
      await linkOfferToBranch(offerId, selectedBranch); // ✅ root id بإسم المسافة
      alert("✅ تم ربط العرض بالفرع بنجاح");
      if (onSuccess) onSuccess();
      onClose();
    } catch (error) {
      alert("❌ " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        borderRadius: 2
      }}>
        <Typography variant="h6" mb={2}>ربط العرض بفرع</Typography>

        <FormControl fullWidth>
          <InputLabel id="branch-select-label">اختر الفرع</InputLabel>
          <Select
            labelId="branch-select-label"
            value={selectedBranch}
            onChange={(e) => setSelectedBranch(e.target.value)}
            label="اختر الفرع"
          >
            {branches.map((branch) => (
              <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading || !selectedBranch}
          >
            {loading ? <CircularProgress size={24} /> : "تنفيذ الربط"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default LinkOfferModal;
